export default __webpack_public_path__ + "static/media/chestguard_of_the_defiant.d8237d49.jpg";